export default __webpack_public_path__ + "static/media/logo.03492871.png";